<template>
  <v-col>
    <v-row>
      <v-spacer />
      <v-btn
        icon
        class="info--text"
        large
        :disabled="threshold < 1"
        @click="threshold--"
      >
        <v-icon>mdi-minus-circle</v-icon>
      </v-btn>
      <v-spacer />
      <v-text-field
        v-model="threshold"
        hide-details="auto"
        label="Alert threshold"
        outlined
        :loading="loading"
        dense
        min="0"
        prepend-inner-icon="mdi-flash-outline"
        type="number"
        :messages="
          products.length +
            ' product(s) found has quantity under threshold  ' +
            threshold
        "
      />
      <v-spacer />
      <v-btn
        class="info--text"
        icon
        large
        @click="threshold++"
      >
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
      <v-spacer />
    </v-row>

    <v-row>
      <v-col
        v-for="product in products"
        :key="product.id"
        cols="12"
        md="4"
        sm="6"
        class="pa-1"
      >
        <v-badge
          bordered
          color="error"
          :content="product.qty"
          overlap
        >
          <v-alert
            border="left"
            outlined
            dense
            type="error"
            class="mb-1"
          >
            <strong>{{ product.name | uppercase }}</strong>
            ({{ product.barcode }})
          </v-alert>
        </v-badge>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      productsOrg: [],
      threshold: 20,
      loading: false,
    };
  },
  computed: {
    products() {
      this.loading = true;
      const items = this.productsOrg.filter((item) => {
        return Number(item.qty) < Number(this.threshold) ? item : null;
      });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      return items;
    },
  },
  mounted() {
    this.getBasicData();
  },
  methods: {
    getBasicData() {
      window.axios.get("/product-form-data").then((response) => {
        this.productsOrg = response.data.products;
      });
    },
  },
};
</script>
